"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreditScore = exports.WrappedApplyNow = exports.WAIVED_FIRST_YEAR_STRING = exports.TRANSUNION_LOGO_CTA = exports.DISCLAIMER_TEXT = void 0;
Object.defineProperty(exports, "getQuickFactAnnualFee", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverAnnualFee;
  }
});
Object.defineProperty(exports, "getQuickFactBalanceTransferFeeDescription", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverBalanceTransferFeeDescription;
  }
});
Object.defineProperty(exports, "getQuickFactEstBonusValue", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverBonus;
  }
});
Object.defineProperty(exports, "getQuickFactIntroApr", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverIntroApr;
  }
});
Object.defineProperty(exports, "getQuickFactIntroOffer", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverIntroOffer;
  }
});
exports.getQuickFactLikelihoodOfApprovalText = exports.getQuickFactLikelihoodOfApproval = void 0;
Object.defineProperty(exports, "getQuickFactMinimumDepositDescription", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverMinimumDepositDescription;
  }
});
Object.defineProperty(exports, "getQuickFactRecommendedCreditScoreRange", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverRecommendedCreditScoreRange;
  }
});
exports.getQuickFactRegularApr = void 0;
Object.defineProperty(exports, "getQuickFactRewardRate", {
  enumerable: true,
  get: function get() {
    return _creditCards3.getDriverRewardRate;
  }
});
exports.getQuickFactStarRating = void 0;
Object.defineProperty(exports, "getRecommendedCreditScoreFormattedDetails", {
  enumerable: true,
  get: function get() {
    return _creditCards2.getRecommendedCreditScoreFormattedDetails;
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Box = require("@nerdwallet/currency/components/Box");
var _Type = require("@nerdwallet/currency/components/Type");
var _react = _interopRequireWildcard(require("react"));
var _impression = require("@nerdwallet/analytics/react/impression");
var _variables = require("@nerdwallet/base-styles/variables");
var _creditCards = require("@nerdwallet/marketplace/selectors/credit-cards");
var _creditCards2 = require("@nerdwallet/marketplace/utils/credit-cards");
var _reactMarketplaceApplyNow = _interopRequireWildcard(require("@nerdwallet/react-marketplace-apply-now"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _reactMarketplaceStarRating = _interopRequireWildcard(require("@nerdwallet/react-marketplace-star-rating"));
var _utils = require("./utils");
var _constants = require("../constants");
var _quickFactsModule = _interopRequireDefault(require("../quick-facts.module.css"));
var _creditCards3 = require("@nerdwallet/marketplace/drivers/credit-cards");
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/drivers/credit-cards` directly.
 */

// copied from @nerdwallet/likelihood-of-approval
var CREDIT_DASHBOARD_PATH_WITH_TRK = '/home/dashboard/credit-score?trk_channel=web&trk_element=hyperlink&trk_location=likelihood_of_approval';
var AO_COLORS = {
  DEFAULT: _variables.colors['neutral-lighter'],
  DEFAULT_BACKGROUND: _variables.colors['neutral-lightest'],
  LOW: _variables.colors['red-light'],
  MEDIUM: _variables.colors.yellow,
  HIGH: _variables.colors['green-dark']
};
var AO_RANGES = {
  LOW: {
    min: 0,
    max: 0.45
  },
  MEDIUM: {
    min: 0.45,
    max: 0.65
  },
  HIGH: {
    min: 0.65,
    max: 1
  }
};

// copied from @nerdwallet/likelihood-of-approval
var getColorAndLabel = function getColorAndLabel(props) {
  var approvalOdds = props.approvalOdds;
  if (approvalOdds < AO_RANGES.LOW.max) {
    return {
      color: AO_COLORS.LOW,
      label: 'poor'
    };
  }
  if (approvalOdds >= AO_RANGES.MEDIUM.min && approvalOdds < AO_RANGES.MEDIUM.max) {
    return {
      color: AO_COLORS.MEDIUM,
      label: 'good'
    };
  }
  if (approvalOdds >= AO_RANGES.HIGH.min) {
    return {
      color: AO_COLORS.HIGH,
      label: 'excellent'
    };
  }
  return {
    color: AO_COLORS.DEFAULT,
    label: ''
  };
};

// copied from @nerdwallet/likelihood-of-approval
var getCreditScoreComparisonContent = function getCreditScoreComparisonContent(creditScore, creditScoreBucketValueMax, creditScoreBucketValueMin) {
  var creditScoreComparisonContent = {};
  if (creditScore >= creditScoreBucketValueMax) {
    creditScoreComparisonContent.relativeScoreLabel = 'above the highest';
    creditScoreComparisonContent.scoreToCompare = creditScoreBucketValueMax;
    creditScoreComparisonContent.pointDifference = creditScore - creditScoreBucketValueMax;
  } else if (creditScore >= creditScoreBucketValueMin) {
    creditScoreComparisonContent.relativeScoreLabel = 'above the lowest';
    creditScoreComparisonContent.scoreToCompare = creditScoreBucketValueMin;
    creditScoreComparisonContent.pointDifference = creditScore - creditScoreBucketValueMin;
  } else {
    creditScoreComparisonContent.relativeScoreLabel = 'below the lowest';
    creditScoreComparisonContent.scoreToCompare = creditScoreBucketValueMin;
    creditScoreComparisonContent.pointDifference = creditScoreBucketValueMin - creditScore;
  }
  creditScoreComparisonContent.pointDifference = creditScoreComparisonContent.pointDifference === 1 ? '1 point' : "".concat(creditScoreComparisonContent.pointDifference, " points");
  return creditScoreComparisonContent;
};

/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage export from `@nerdwallet/marketplace/utils/credit-cards` directly.
 */

var WAIVED_FIRST_YEAR_STRING = 'Waived first year';
exports.WAIVED_FIRST_YEAR_STRING = WAIVED_FIRST_YEAR_STRING;
var DISCLAIMER_TEXT = 'But, heads up, being within the recommended range doesn’t guarantee approval. Credit score is only one factor lenders consider and they may not use the TransUnion Vantage Score like we do.';
exports.DISCLAIMER_TEXT = DISCLAIMER_TEXT;
var TRANSUNION_LOGO_CTA = /*#__PURE__*/_react.default.createElement("a", {
  href: CREDIT_DASHBOARD_PATH_WITH_TRK,
  target: "_",
  className: (0, _classes.default)('display-block')
}, /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)('tu-logo', _quickFactsModule.default.tuLogo)
}));

/**
 * A getter for credit score given identity object.
 *
 * @param {object} options
 * @param {object} options.identity
 */
exports.TRANSUNION_LOGO_CTA = TRANSUNION_LOGO_CTA;
var getCreditScore = function getCreditScore(options) {
  return (0, _get2.default)(options, 'identity.profiles.tu_credit_report_profile.vantage_score_3');
};

/**
 * @todo - Create Structured Content compatible value, tooltip and backport into `@nerdwallet/marketplace/drivers/credit-cards`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 *
 * Get the likelihood of approval text quick fact
 * This is for the Keto Card AB test to replace the `getQuickFactLikelihoodOfApproval`
 *
 * |-------------------------------------------------------------------------------------------|
 * |                  |  TU-activated          | Not TU-activated                              |
 * |-------------------------------------------------------------------------------------------|
 * |Approval odds     |  approval odds text    | Show text-based rec score & approval odds cta |
 * |-------------------------------------------------------------------------------------------|
 * |No approval odds  |  Show user's score     | Show text-based rec score & approval odds cta |
 * |-------------------------------------------------------------------------------------------|
 * @param   {Object}  offer                          The CC offer.
 * @param   {Object}  options
 * @param   {Object}  options.analytics              Analytics details for the AO impression.
 * @param   {boolean} options.approvalOddsEnabled    Flag to enabled or disable approvalOdds
 * @param   {Object}  options.identity               The identity object typically found in state
 *                                                   This is used to determine if the user is logged in
 *                                                   as well as the user's credit score
 * @param   {node}    options.ctaComponent           A custom CTA Component. MPC currently passes one
 *                                                   in for getQuickFactLikelihoodOfApproval()
 * @return  {Object}                                 The likelihood of approval text quick fact
 */
exports.getCreditScore = getCreditScore;
var getQuickFactLikelihoodOfApprovalText = function getQuickFactLikelihoodOfApprovalText(offer) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var minCreditScoreIndex = (0, _creditCards.getMinimumFICO)(offer);
  var maxCreditScoreIndex = (0, _creditCards.getMaximumFICO)(offer);
  if (!(minCreditScoreIndex && maxCreditScoreIndex)) {
    return null;
  }
  var recommendedCreditScoreText = (0, _creditCards2.getRecommendedCreditScoreFormattedDetails)(offer, maxCreditScoreIndex, minCreditScoreIndex);
  var approvalOdds = options.approvalOddsEnabled ? (0, _creditCards.getApprovalOdds)(offer) : null;
  var creditScore = getCreditScore(options);
  var analytics = options.analytics;
  var loaLabel = 'Recommended Credit Score';
  var loaLabelTooltip;
  var loaValue;
  var loaValueTooltip;
  if (approvalOdds && creditScore) {
    var approvalOddsText = getColorAndLabel({
      approvalOdds: approvalOdds
    }).label;
    loaValue = /*#__PURE__*/_react.default.createElement(_impression.Impression, {
      className: _quickFactsModule.default.loaValueWrapper,
      entityName: "cc_approval_odds",
      eventType: "approval_odds_element_impression",
      payload: {
        section_name: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName,
        section_position: analytics === null || analytics === void 0 ? void 0 : analytics.sectionPosition,
        additional_attributes: {
          approval_odds: approvalOddsText
        }
      }
    }, (0, _capitalize2.default)(approvalOddsText));
    loaLabel = 'Your approval odds';
    loaValueTooltip = /*#__PURE__*/_react.default.createElement(_Box.Box, {
      className: _quickFactsModule.default.popoverContent
    }, /*#__PURE__*/_react.default.createElement(_Type.Type, {
      size: 1
    }, "We think your odds of getting approved for this card are", /*#__PURE__*/_react.default.createElement(_Type.Type, {
      size: 1,
      bold: true,
      className: _quickFactsModule.default.popoverOdds
    }, "\xA0", getColorAndLabel({
      approvalOdds: approvalOdds
    }).label, "\xA0"), "based on your credit score and other factors. That said, these odds are an estimate to help you narrow your choices, not a guarantee. Card issuers may use different criteria than we do."));
  } else if (!approvalOdds && creditScore) {
    // note that @quick-fact-max-width is limiting the full extension of the loavalue for desktop in the current grid layout
    loaValue = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classes.default)('display-flex')
    }, /*#__PURE__*/_react.default.createElement("div", null, creditScore), /*#__PURE__*/_react.default.createElement("div", null, TRANSUNION_LOGO_CTA)), /*#__PURE__*/_react.default.createElement("div", null, "(".concat(recommendedCreditScoreText.creditScoreRange, ")")));
    var creditScoreComparisonContent = getCreditScoreComparisonContent(creditScore, maxCreditScoreIndex, minCreditScoreIndex);
    loaLabelTooltip = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Type.Type, {
      className: (0, _classes.default)(['color-neutral-darkest', 'margin-bottom-2'])
    }, "You're", /*#__PURE__*/_react.default.createElement("strong", null, " ".concat(creditScoreComparisonContent.pointDifference)), " ".concat(creditScoreComparisonContent.relativeScoreLabel, " suggested score of "), /*#__PURE__*/_react.default.createElement("strong", null, creditScoreComparisonContent.scoreToCompare), "."), /*#__PURE__*/_react.default.createElement(_Type.Type, {
      className: (0, _classes.default)(['color-neutral-darkest'])
    }, DISCLAIMER_TEXT));
  } else {
    loaValue = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classes.default)('display-flex--wide')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classes.default)('margin-right-1')
    }, recommendedCreditScoreText.creditScoreRange), /*#__PURE__*/_react.default.createElement("div", null, "(".concat(recommendedCreditScoreText.creditScoreRangeDescription, ")"))), /*#__PURE__*/_react.default.createElement("div", null, options.ctaComponent));
  }
  return {
    id: 'likelihoodOfApproval',
    label: loaLabel,
    labelTooltip: loaLabelTooltip,
    value: !(0, _isEmpty2.default)(offer) ? loaValue : null,
    valueSize: _constants.VALUE_SIZES.MEDIUM,
    valueTooltip: loaValueTooltip
  };
};
exports.getQuickFactLikelihoodOfApproval = exports.getQuickFactLikelihoodOfApprovalText = getQuickFactLikelihoodOfApprovalText;
// exporting for the styleguide
var WrappedApplyNow = function WrappedApplyNow(_ref) {
  var impressionId = _ref.impressionId,
    marketplaceEntity = _ref.marketplaceEntity,
    sectionName = _ref.sectionName,
    shouldLogImpression = _ref.shouldLogImpression,
    termsAndFeesLink = _ref.termsAndFeesLink;
  var impressionContext = (0, _react.useContext)(_impression.ImpressionContext);
  return /*#__PURE__*/_react.default.createElement(_reactMarketplaceApplyNow.default, {
    className: _quickFactsModule.default.secondaryCta,
    finishType: _reactMarketplaceApplyNow.APPLY_NOW_FINISH_TYPES.EXTERNAL_CONTENT,
    impressionId: impressionId !== null && impressionId !== void 0 ? impressionId : impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    id: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    link: termsAndFeesLink,
    linkType: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    marketplaceEntity: marketplaceEntity,
    monetizable: (0, _utils.getMonetizable)(marketplaceEntity),
    sectionName: sectionName,
    type: _reactMarketplaceApplyNow.LINK_TYPES.LINK,
    shouldLogImpression: shouldLogImpression
  }, "Rates & Fees");
};
exports.WrappedApplyNow = WrappedApplyNow;
if (process.env.NODE_ENV !== 'production') {
  var PropTypes = require('prop-types'); // eslint-disable-line global-require
  WrappedApplyNow.propTypes = {
    impressionId: PropTypes.string,
    marketplaceEntity: PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    sectionName: PropTypes.string,
    shouldLogImpression: PropTypes.bool,
    termsAndFeesLink: PropTypes.string
  };
}

/**
 * @todo - Create Structured Content compatible description and backport into `@nerdwallet/marketplace/drivers/credit-cards`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 */
var getQuickFactRegularApr = function getQuickFactRegularApr(offer) {
  var _productImpressionPro;
  var includeRatesAndFeesLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shouldLogImpression = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var productImpressionProps = arguments.length > 3 ? arguments[3] : undefined;
  var termsAndFeesLink = (0, _creditCards.getTermsAndFeesLink)(offer);
  return {
    id: 'regularApr',
    label: 'Regular APR',
    value: (0, _creditCards.getOngoingAPR)(offer),
    valueSize: _constants.VALUE_SIZES.MEDIUM,
    description: includeRatesAndFeesLink && termsAndFeesLink ? /*#__PURE__*/_react.default.createElement(WrappedApplyNow, {
      impressionId: productImpressionProps === null || productImpressionProps === void 0 ? void 0 : productImpressionProps.productImpressionId,
      marketplaceEntity: offer,
      sectionName: productImpressionProps === null || productImpressionProps === void 0 ? void 0 : (_productImpressionPro = productImpressionProps.payload) === null || _productImpressionPro === void 0 ? void 0 : _productImpressionPro.section_name,
      shouldLogImpression: shouldLogImpression,
      termsAndFeesLink: termsAndFeesLink
    }) : null
  };
};

/**
 * @todo - Create Structured Content compatible value and backport into `@nerdwallet/marketplace/drivers/credit-cards`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 *
 * Get the star rating.
 * @param   {Object}  offer  The CC offer.
 * @return  {Object}  The star rating.
 */
exports.getQuickFactRegularApr = getQuickFactRegularApr;
var getQuickFactStarRating = function getQuickFactStarRating(offer, starRatingProps) {
  if (!(starRatingProps !== null && starRatingProps !== void 0 && starRatingProps.showNotYetRated) && !((0, _isNumber2.default)(starRatingProps === null || starRatingProps === void 0 ? void 0 : starRatingProps.starRating) || (0, _isNumber2.default)((0, _creditCards.getStarRating)(offer)))) {
    return null;
  }
  var starRating = /*#__PURE__*/_react.default.createElement(_reactMarketplaceStarRating.default, (0, _extends2.default)({
    marketplaceEntity: offer,
    layout: _reactMarketplaceStarRating.LAYOUTS.SMALL_NUMERIC,
    omitRatingNumberHref: false,
    hideRatingText: true,
    className: (0, _classnames.default)((0, _classes.default)('display-inline-flex'), _quickFactsModule.default.starRatingValue)
  }, starRatingProps));
  return {
    id: 'starRating',
    label: 'NerdWallet rating',
    value: starRating,
    valueSize: _constants.VALUE_SIZES.MEDIUM,
    valueTooltip: _reactMarketplaceStarRating.TOOLTIP_TEXT.credit_cards
  };
};
exports.getQuickFactStarRating = getQuickFactStarRating;